<template>
  <div>
    <template v-if="showHeader && database">
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <v-row class="mt-10">
        <v-col class="d-flex pt-0">
          <img
            src="../../assets/icons/sorts/resource_center.png"
            class="tcdc-resource-center-layout-icon mr-4"
          />
          <span class="text-tcdc-green bold header text-uppercase">resource center</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="text-tcdc-green header bold text-uppercase">{{database[`title_${lang}`]}}</span>
        </v-col>
      </v-row>
    </template>
    <v-row class="my-8">
      <v-col>
        <span
          class="bold header grey--text"
        >{{database[`description_${lang}`]}}
        </span>
      </v-col>
    </v-row>
    <v-row class="mb-8">
      <v-col>
        <a @click="goToWebsite(database.attached_website)">
          <GreenButton label="visit website" />
        </a>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ImageCarousel :images="database.slide_images"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GreenButton from "../../components/buttons/GreenButton";
import ImageCarousel from "../../components/carousels/ImageCarousel";
import { mapState } from "vuex";

export default {
  components: {
    GreenButton,
    ImageCarousel
  },
  props: {
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.items[0].text = this.branchName;
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      database : state=> state.ServiceMenu.resource_centers.database,
      lang: state => state.Branch.lang
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  methods:{
    goToWebsite(url){
      if(url){
        window.open(url,'_blank')
      }
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home"
      },
      {
        text: "SERVICE",
        disabled: false,
        href: "/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/service/resource-center"
      },
      {
        text: "DATABASE",
        disabled: true,
      }
    ]
  })
};
</script>

<style>
</style>
